import * as types from './types';

const userCheckAbleModify = () => ({
  type: types.USER_CHECK_ABLE_MODIFY,
  meta: {
    async: true,
    api: 'users',
    path: `/v1/users/ismodifiable/phone-email/`,
    method: 'GET'
  }
});

const userPhoneCheck = (countryCode, phone, type) => ({
  type: types.USER_PHONE_CHECK,
  meta: {
    async: true,
    api: 'users',
    path: '/v1/users/validation/phone/',
    query: { country_code: countryCode, phone, type },
    method: 'GET',
    data: { countryCode, phone, type },
    id: type
  }
});

const setPhoneCounter = counter => ({
  type: types.USER_PHONE_SET_COUNTER,
  meta: {
    counter
  }
});

const resetPhoneCheck = () => ({
  type: types.USER_PHONE_CHECK_RESET
});

export { userCheckAbleModify, userPhoneCheck, setPhoneCounter, resetPhoneCheck };
